import {
    ListItem,
    ListItemText,
    Paper,
} from "@material-ui/core";
import React from "react";
import Course from "../../../Common/Models/Course";
import styled from "styled-components";

interface CourseListItemProps {
    course: Course;
    onClick: (course: Course) => void;
}

const Container = styled(Paper)`
  margin-bottom: 16px;
`;

export const CourseListItem = (props: CourseListItemProps) => {
    const {course, onClick} = props;

    return (
        <Container variant={'outlined'}>
            <ListItem
                button
                onClick={() => onClick(course)}
            >
                <ListItemText
                    primary={course.title}
                    primaryTypographyProps={{align:'center'}}
                />
            </ListItem>
        </Container>
    );
};